import React, { useEffect, useState, useCallback } from "react";
import ReactPlayer from "react-player";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
// Añadimos Header de Semantic UI para consistencia, aunque se puede usar h2 directamente
import { Header } from "semantic-ui-react";
import "./Module4.scss";

const virtualScenesController = new VirtualScenes();

export function Module4({ refId }) {
  const module4 = "module_04";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ... (lógica de fetch sin cambios)
  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module4
      );
      setModuleData(data.moduleData);
    } catch (err) {
      console.error("Error al obtener los datos del módulo:", err);
      setError("Error al cargar el módulo");
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module4]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);


  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  // 1. LÓGICA MEJORADA: Obtenemos la URL del vídeo de forma segura.
  // Esto devolverá `undefined` si `ModFourVideo` no existe, es un array vacío,
  // o si el primer elemento es null o una cadena vacía, lo que simplifica la condición.
  const videoUrl = moduleData?.ModFourVideo?.[0];

  return (
    <div className="module4-container">
      {/* Título estandarizado con la clase .block-title */}
      <Header as="h2" className="block-title">
        {moduleData?.ModFourTitle || "Título del Módulo 4"}
      </Header>
      <Header as="h3" className="module4-subtitle">
        {moduleData?.ModFourSubtitle}
      </Header>

      {/* Contenido HTML. CORREGIDO: Se usaba ModThreeSubcontent por error */}
      {/* VERIFICAR: Asegúrate que 'ModFourContent' es el nombre correcto del campo de tu API */}
      <div
        className="module4-subcontent"
        dangerouslySetInnerHTML={{
          __html: moduleData?.ModFourContent || "",
        }}
      />

      {/* Casos de Uso: ahora usan el estilo .framed-box */}
      <div className="module4-usecases">
        {moduleData?.ModFourUsescases?.map((usecase) => (
          // Aplicamos la clase .framed-box para unificar el estilo
          <div key={usecase._id} className="framed-box">
            <h4 className="usecase-title">{usecase.title}</h4>
            <div
              dangerouslySetInnerHTML={{
                __html: usecase.description || "",
              }}
            />
          </div>
        ))}
      </div>

      {/* Vídeo: Se renderiza solo si 'videoUrl' es una cadena de texto válida */}
      {videoUrl && (
        <div className="video-wrapper">
          <ReactPlayer
            url={videoUrl}
            controls
            className="react-player"
            width="100%"
            height="100%"
          />
        </div>
      )}
    </div>
  );
}